import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import styles from "../agent-response.module.scss";

type DataTalkSqlGeneratorAgentProps = {
    parsedContent: any;
};

export default function DataTalkSqlGeneratorAgent({
    parsedContent,
}: DataTalkSqlGeneratorAgentProps): JSX.Element {
    const answer = safeJSONParse(parsedContent?.finalAnswer);
    const question = parsedContent?.question;
    const responseData = answer;

    return (
        <div className={styles.pressReleaseContent}>
            {/* Response Type */}
            {responseData?.response_type && (
                <div style={{ marginBottom: "12px" }}>
                    <h3 style={{ marginBottom: "7px" }}>
                        SQL Query Generation
                    </h3>
                    <p style={{ marginBottom: "0" }}>
                        <strong>Status:</strong>{" "}
                        <span style={{
                            textTransform: "capitalize",
                            color: responseData.response_type === "success" ? "#4caf50" : "#f44336",
                            fontWeight: "500"
                        }}>
                            {responseData.response_type}
                        </span>
                    </p>
                </div>
            )}

            {/* SQL Query */}
            {responseData?.result?.sql_query && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Generated SQL Query:</h4>
                    <div style={{
                        marginTop: "8px",
                        padding: "12px",
                        backgroundColor: "#f5f5f5",
                        borderLeft: "4px solid #2196f3",
                        borderRadius: "4px",
                        fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace"
                    }}>
                        <pre style={{
                            margin: "0",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            fontSize: "13px",
                            lineHeight: "1.5",
                            color: "#333"
                        }}>
                            {responseData.result.sql_query}
                        </pre>
                    </div>
                </div>
            )}

            {/* Explanation */}
            {responseData?.result?.explanation && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0" }}>Query Explanation:</h4>
                    <div style={{
                        marginTop: "8px",
                        padding: "12px",
                        backgroundColor: "#e3f2fd",
                        borderLeft: "4px solid #2196f3",
                        borderRadius: "4px"
                    }}>
                        <p style={{
                            margin: "0",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            fontSize: "13px",
                            lineHeight: "1.6"
                        }}>
                            {responseData.result.explanation}
                        </p>
                    </div>
                </div>
            )}

            {/* Estimated Result Type */}
            {responseData?.result?.estimated_result_type && (
                <div style={{ marginBottom: "12px" }}>
                    <h5 style={{ marginBottom: "4px", fontSize: "14px", color: "#666" }}>
                        Expected Result:
                    </h5>
                    <div style={{
                        padding: "10px",
                        backgroundColor: "#fff",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        fontSize: "13px"
                    }}>
                        <p style={{
                            margin: "0",
                            fontStyle: "italic",
                            color: "#555"
                        }}>
                            {responseData.result.estimated_result_type}
                        </p>
                    </div>
                </div>
            )}

            {/* Blocked/Error Message */}
            {responseData?.blocked && (
                <div style={{ marginBottom: "12px" }}>
                    <h4 style={{ marginBottom: "0", color: "#f44336" }}>Error:</h4>
                    <div style={{
                        marginTop: "8px",
                        padding: "12px",
                        backgroundColor: "#ffebee",
                        borderLeft: "4px solid #f44336",
                        borderRadius: "4px"
                    }}>
                        <p style={{
                            margin: "0",
                            color: "#c62828",
                            fontSize: "13px"
                        }}>
                            {responseData.blocked}
                        </p>
                    </div>
                </div>
            )}

            {/* Final Question */}
            {question && (
                <div className={styles.finalQuestion}>{question}</div>
            )}
        </div>
    );
}
